export interface Post {
  image: string;
  alt: string;
  slug: string;
  title: string;
  excerpt: string;
  author: {
    name: string;
    avatar: string;
  };
  publishedAt: string;
  readingTime: number;
  content: string;
  tags: string[];
  category: string;
}

export const posts: Post[] = [
  // ============================================================
  // 1) Emergência 24h
  // ============================================================
  {
    image: "/blog/emergencia-24h.jpg",
    alt: "veterinário cuidando de um cachorro",
    slug: "emergencia-veterinaria-24h-lages",
    title:
      "Emergência veterinária 24h em Lages – SC: o que fazer e quando ligar",
    excerpt:
      "Saiba como agir em uma emergência veterinária em Lages – SC, quais sinais exigem atendimento imediato e quando ligar para a clínica 24h da São Chico.",
    author: {
      name: "Clínica Veterinária São Chico",
      avatar: "/images/authors/sao-chico.png",
    },
    publishedAt: "2025-11-11",
    readingTime: 6,
    category: "Emergência",
    tags: [
      "emergência veterinária",
      "urgência 24h",
      "Lages SC",
      "primeiros socorros para pets",
      "clínica veterinária",
    ],
    content: `
      <h3><strong>Quando procurar emergência veterinária 24h</strong></h3>
      <p>Quando o pet passa mal à noite, nos fins de semana ou feriados, cada minuto conta. 
      Reconhecer sinais de alerta e agir corretamente antes de chegar à clínica pode salvar vidas. 
      A São Chico atende 24h em Lages – SC pelo telefone <strong>(49) 99982-7046</strong>.</p>

      <h3><strong>Sinais que exigem atendimento imediato</strong></h3>
      <ul>
        <li>Dificuldade para respirar ou gengivas arroxeadas;</li>
        <li>Convulsões, desmaios ou desorientação;</li>
        <li>Fraturas, trauma ou sangramento ativo;</li>
        <li>Suspeita de envenenamento (iscas, plantas, produtos químicos);</li>
        <li>Dor intensa, abdômen distendido ou vômitos com sangue;</li>
        <li>Golpe de calor ou hipotermia;</li>
        <li>Falta de apetite prolongada em gatos.</li>
      </ul>

      <h3><strong>O que fazer antes de sair de casa</strong></h3>
      <ul>
        <li>Mantenha a calma e evite manusear demais o animal;</li>
        <li>Ligue para <strong>(49) 99982-7046</strong> e descreva os sinais;</li>
        <li>Não ofereça medicamentos humanos;</li>
        <li>Comprima sangramentos com gaze limpa;</li>
        <li>Em convulsões, afaste objetos e não coloque nada na boca;</li>
        <li>Transporte seguro em caixa ou colchonete.</li>
      </ul>

      <h3><strong>Como é o atendimento 24h na São Chico</strong></h3>
      <p>Realizamos triagem imediata, estabilização, analgesia e exames rápidos como RX e ultrassom.
      Dependendo do quadro, o pet pode receber alta ou ser internado com monitoramento.</p>

      <h3><strong>Prevenção no dia a dia</strong></h3>
      <ul>
        <li>Vacinação e vermifugação em dia;</li>
        <li>Controle de pulgas e carrapatos;</li>
        <li>Produtos químicos fora do alcance;</li>
        <li>Transporte seguro e atenção ao calor do carro.</li>
      </ul>

      <blockquote>
        <p><strong>Dica São Chico:</strong> mantenha o número da emergência salvo no celular. Isso faz diferença em momentos críticos!</p>
      </blockquote>
    `,
  },

  // ============================================================
  // 2) Vacinação
  // ============================================================
  {
    image: "/blog/vacinacao.jpg",
    alt: "veterinário aplicando vacina em cachorro",
    slug: "vacinacao-pet-lages-calendario",
    title:
      "Vacinas para cães e gatos em Lages – SC: calendário, valores e dúvidas",
    excerpt:
      "Conheça o calendário essencial de vacinação de cães e gatos em Lages – SC, mitos comuns e como manter a proteção do seu pet sempre em dia.",
    author: {
      name: "Clínica Veterinária São Chico",
      avatar: "/images/authors/sao-chico.png",
    },
    publishedAt: "2025-11-11",
    readingTime: 6,
    category: "Vacinação",
    tags: ["vacinas pet", "cães e gatos", "Lages SC", "saúde preventiva"],
    content: `
      <h3><strong>Importância da vacinação</strong></h3>
      <p>A vacinação protege contra doenças graves e é obrigatória para hospedagem, viagens e day care.
      Na São Chico, a aplicação é segura e orientada individualmente.</p>

      <h3><strong>Calendário básico para cães</strong></h3>
      <ul>
        <li>Filhotes: protocolo V8/V10 em 3–4 doses;</li>
        <li>Raiva: a partir de 12 semanas, reforço anual;</li>
        <li>Tosse dos canis: conforme risco e rotina.</li>
      </ul>

      <h3><strong>Calendário básico para gatos</strong></h3>
      <ul>
        <li>V3/V4/V5: série inicial e reforço anual;</li>
        <li>Raiva: conforme legislação municipal.</li>
      </ul>

      <h3><strong>Mitos e verdades</strong></h3>
      <ul>
        <li>“Pet indoor não precisa vacinar”: falso;</li>
        <li>“Vacina sempre dá reação”: reações são raras;</li>
        <li>“Uma dose basta”: reforços são essenciais para imunidade duradoura.</li>
      </ul>

      <h3><strong>Segurança na São Chico</strong></h3>
      <p>Trabalhamos com cadeia de frio controlada, avaliação prévia e registro em carteirinha.</p>

      <blockquote>
        <p><strong>Dica São Chico:</strong> mantenha lembretes de reforço para evitar atrasos no calendário.</p>
      </blockquote>
    `,
  },

  // ============================================================
  // 3) Banho e Tosa
  // ============================================================
  {
    image: "/blog/banho-e-tosa.jpg",
    alt: "cachorro sendo tosado em pet shop",
    slug: "banho-e-tosa-lages-frequencia-cuidados",
    title: "Banho e tosa em Lages – SC: frequência ideal e cuidados por raça",
    excerpt:
      "Frequência ideal de banho e tosa por tipo de pelagem, cuidados dermatológicos e como o clima serrano de Lages influencia a saúde do pet.",
    author: {
      name: "Clínica Veterinária São Chico",
      avatar: "/authors/sao-chico.png",
    },
    publishedAt: "2025-11-11",
    readingTime: 5,
    category: "Estética",
    tags: [
      "banho e tosa",
      "cuidados pet",
      "Lages SC",
      "dermatologia veterinária",
    ],
    content: `
      <h3><strong>Influência do clima serrano</strong></h3>
      <p>O clima de Lages, frio e úmido em várias épocas do ano, afeta diretamente pele e pelagem.
      Um cronograma adequado evita dermatites, nós e desconforto.</p>

      <h3><strong>Frequência orientativa</strong></h3>
      <ul>
        <li>Cães de pelo curto: a cada 3–4 semanas;</li>
        <li>Cães de pelo longo: a cada 2–3 semanas com hidratação;</li>
        <li>Gatos: conforme tolerância e rotina da casa.</li>
      </ul>

      <h3><strong>Sinais de alerta</strong></h3>
      <ul>
        <li>Coceira persistente e mau odor;</li>
        <li>Descamação e queda de pelo;</li>
        <li>Nós doloridos ou lesões;</li>
        <li>Alta incidência de pulgas e carrapatos em épocas quentes.</li>
      </ul>

      <h3><strong>Boas práticas</strong></h3>
      <ul>
        <li>Produtos dermatológicos adequados para a espécie;</li>
        <li>Secagem completa para evitar fungos;</li>
        <li>Supervisão veterinária para pets com histórico de pele.</li>
      </ul>

      <blockquote>
        <p><strong>Dica São Chico:</strong> a escovação semanal reduz nós e melhora a saúde da pele.</p>
      </blockquote>
    `,
  },

  // ============================================================
  // 4) Consulta Veterinária
  // ============================================================
  {
    image: "/blog/consulta.jpg",
    alt: "veterinário examinando um cachorro",
    slug: "consulta-veterinaria-lages-quando-levar",
    title:
      "Consulta veterinária em Lages – SC: quando levar e o que está incluso",
    excerpt:
      "Veja quando agendar consulta veterinária em Lages – SC, o que está incluso no atendimento e como funciona o acompanhamento pós-consulta.",
    author: {
      name: "Clínica Veterinária São Chico",
      avatar: "/images/authors/sao-chico.png",
    },
    publishedAt: "2025-11-11",
    readingTime: 6,
    category: "Consulta",
    tags: ["consulta veterinária", "check-up pet", "Lages SC", "saúde animal"],
    content: `
      <h3><strong>Quando levar seu pet</strong></h3>
      <p>Coceira persistente, vômitos recorrentes, apatia, dor, perda de peso ou mudanças de comportamento
      são sinais que exigem avaliação. Filhotes, adultos e idosos têm cronogramas diferentes de check-up.</p>

      <h3><strong>O que esperar da consulta</strong></h3>
      <ul>
        <li>Anamnese completa com histórico e rotina;</li>
        <li>Exame físico detalhado;</li>
        <li>Avaliação de pele, dentes, ouvidos e peso;</li>
        <li>Exames complementares quando necessários.</li>
      </ul>

      <h3><strong>Custo e etapas</strong></h3>
      <p>O valor varia conforme horário e complexidade. Após anamnese,
      solicitamos apenas exames realmente necessários.</p>

      <h3><strong>Pós-consulta</strong></h3>
      <ul>
        <li>Prescrições claras e retorno programado;</li>
        <li>Orientações sobre alergias, peso e prevenção;</li>
        <li>Canal direto para dúvidas: <strong>(49) 99982-7046</strong>.</li>
      </ul>

      <blockquote>
        <p><strong>Dica São Chico:</strong> consultas regulares previnem doenças silenciosas.</p>
      </blockquote>
    `,
  },
  {
    image: "/blog/pets-verao.jpg",
    alt: "cachorro em dia quente de verão recebendo cuidados",
    slug: "protecao-pets-verao-lages-cuidados-essenciais",
    title: "Proteção para pets no verão em Lages: cuidados essenciais",
    excerpt:
      "Entenda os principais cuidados com cães e gatos no verão em Lages – SC, como prevenir golpe de calor, desidratação e outros riscos comuns da estação.",
    author: {
      name: "Clínica Veterinária São Chico",
      avatar: "/images/authors/sao-chico.png",
    },
    publishedAt: "2026-03-04",
    readingTime: 12,
    category: "Prevenção",
    tags: [
      "proteção para pets no verão",
      "golpe de calor",
      "hidratação pet",
      "Lages SC",
      "cuidados verão",
    ],
    content: `
    <p>O verão em Lages pode trazer dias bem quentes e, com eles, aumentam os riscos para cães e gatos. Por isso, a proteção para pets no verão precisa ir além de “dar água e sombra”. Com algumas ações simples e consistentes, você reduz o risco de desidratação, queimaduras nas patas e até golpe de calor, que é uma emergência.</p>

    <p>Ao longo deste guia, você vai entender o que muda no organismo do pet no calor, quais sinais exigem atenção imediata e como montar uma rotina de prevenção. Assim, você aproveita a estação com mais tranquilidade e segurança.</p>

    <h3><strong>Por que o verão exige mais cuidados com cães e gatos?</strong></h3>
    <p>Diferente dos humanos, cães e gatos não suam como a gente. Eles regulam a temperatura principalmente pela respiração (ofegação) e por pequenas áreas do corpo. Isso significa que, em dias quentes, eles podem superaquecer rápido, especialmente:</p>

    <ul>
      <li>Filhotes e idosos</li>
      <li>Pets braquicefálicos (focinho curto), como Pug, Bulldog e Shih Tzu</li>
      <li>Animais acima do peso</li>
      <li>Pets com doença cardíaca ou respiratória</li>
      <li>Pets de pelagem muito densa</li>
    </ul>

    <p>Além disso, o calor aumenta a necessidade de água e pode piorar quadros de pele, ouvido e estresse.</p>

    <p>Dica prática: se você está desconfortável com o calor, seu pet provavelmente também está.</p>

    <h3><strong>Golpe de calor em pets: o que é e como identificar rápido</strong></h3>
    <p>O golpe de calor (hipertermia) acontece quando a temperatura corporal sobe demais e o corpo não consegue compensar. Em poucas horas (ou até minutos), pode evoluir para falência de órgãos.</p>

    <p><strong>Sinais de alerta</strong></p>
    <p>Fique atento se seu pet apresentar:</p>

    <ul>
      <li>Ofegação intensa e rápida</li>
      <li>Salivação excessiva</li>
      <li>Língua e gengivas muito vermelhas (ou arroxeadas em casos graves)</li>
      <li>Fraqueza, desorientação</li>
      <li>Vômitos/diarreia</li>
      <li>Tremores, dificuldade para ficar em pé</li>
      <li>Desmaio</li>
    </ul>

    <p><strong>O que fazer imediatamente (primeiros socorros)</strong></p>

    <ul>
      <li>Leve o pet para um lugar ventilado e fresco.</li>
      <li>Ofereça água, sem forçar.</li>
      <li>Faça resfriamento com água fresca (não gelada) em barriga, axilas e patas.</li>
      <li>Procure atendimento veterinário o quanto antes.</li>
    </ul>

    <p>⚠️ Evite banho com água gelada ou gelo direto no corpo. Isso pode causar vasoconstrição e piorar a troca de calor.</p>

    <h3><strong>Hidratação inteligente: mais do que “deixar água no pote”</strong></h3>
    <p>A desidratação no verão é comum e silenciosa. Muitos tutores acham que o pet está bem porque “tem água disponível”, mas ele pode não estar bebendo o suficiente.</p>

    <p><strong>Como aumentar o consumo de água</strong></p>

    <ul>
      <li>Espalhe 2 a 4 potes pela casa (locais diferentes).</li>
      <li>Use fonte de água (gatos costumam beber mais assim).</li>
      <li>Adicione cubos de gelo na água (se o pet aceitar).</li>
      <li>Ofereça petiscos hidratantes: melancia sem sementes, pepino, maçã sem sementes (em pequenas porções).</li>
      <li>Para cães, vale usar tapete de lamber com patê próprio para pets + água (consistência mais líquida).</li>
    </ul>

    <p>👉 Para quem busca cuidados com pets no verão, esse ajuste simples costuma reduzir muito problemas gastrointestinais e episódios de indisposição.</p>

    <p>Sinal de desidratação para observar: gengiva seca e pegajosa, cansaço fora do normal e urina bem amarela.</p>

    <h3><strong>Passeios no calor: horário, piso e regra de ouro</strong></h3>
    <p>Passeio é saúde, mas no verão ele precisa de estratégia.</p>

    <p><strong>Melhor horário para passear</strong></p>
    <ul>
      <li>Prefira início da manhã e fim da tarde/noite.</li>
      <li>Evite o intervalo mais quente do dia.</li>
    </ul>

    <p><strong>Cuidado com o asfalto e calçadas</strong></p>
    <p>O risco aqui não é “incômodo”. É queimadura real.</p>

    <p>Teste dos 5 segundos: encoste a mão no chão. Se você não consegue manter por 5 segundos, está quente demais para as patas.</p>

    <p><strong>Dicas práticas para um passeio seguro</strong></p>
    <ul>
      <li>Leve água e faça pausas em sombra.</li>
      <li>Em cães sensíveis, use botinhas (adaptando aos poucos).</li>
      <li>Reduza a intensidade: no calor, o corpo trabalha mais.</li>
    </ul>

    <h3><strong>Sol e pele: queimaduras também acontecem em pets</strong></h3>
    <p>Sim, pets também podem ter queimaduras solares, principalmente:</p>

    <ul>
      <li>Regiões com menos pelo (orelha, focinho, barriga)</li>
      <li>Pets de pelagem clara</li>
      <li>Animais que ficam muito tempo em áreas externas</li>
    </ul>

    <p><strong>Como proteger</strong></p>
    <ul>
      <li>Crie áreas de sombra constante (toldo, telha térmica, cobertura).</li>
      <li>Use protetor solar veterinário (não use protetor humano sem orientação).</li>
      <li>Evite exposição longa ao sol direto.</li>
    </ul>

    <h3><strong>Alimentação no verão: como evitar intoxicações e desconfortos</strong></h3>
    <p>Com calor, o apetite pode cair e o alimento estraga mais rápido.</p>

    <p><strong>Boas práticas</strong></p>
    <ul>
      <li>Não deixe ração úmida exposta por muito tempo.</li>
      <li>Lave potes com mais frequência.</li>
      <li>Se usar alimentação natural, redobre atenção com armazenamento e temperatura.</li>
      <li>Faça porções menores, se o pet estiver “beliscando” o dia todo.</li>
    </ul>

    <p>⚠️ Atenção: vômitos e diarreias no verão podem ser desde mudança de rotina até intoxicação alimentar. Se persistirem, o ideal é avaliação.</p>

    <h3><strong>Pulgas, carrapatos e mosquitos: o verão acelera tudo</strong></h3>
    <p>O calor favorece a multiplicação de parasitas e aumenta risco de doenças transmitidas por vetores.</p>

    <p><strong>O que fazer</strong></p>
    <ul>
      <li>Mantenha antiparasitário em dia (coleira, comprimido ou pipeta, conforme orientação).</li>
      <li>Trate também o ambiente (quintal, caminhas, frestas).</li>
      <li>Use telas e evite água parada para reduzir mosquitos.</li>
    </ul>

    <p>👉 Em regiões com variação de temperatura, como Lages e arredores, o “sobe e desce” do clima pode confundir o tutor. Mesmo assim, verão é temporada de pico para muitos parasitas.</p>

    <h3><strong>Banho e tosa no verão: o que ajuda e o que pode piorar</strong></h3>
    <p>Banho pode ajudar no conforto térmico, mas não deve virar “resfriamento de emergência” sem critério.</p>

    <p><strong>Banho: sim, com atenção</strong></p>
    <ul>
      <li>Banhos mais frequentes podem ser ok, desde que a pele não resseque.</li>
      <li>Use produtos adequados e observe coceiras.</li>
    </ul>

    <p><strong>E a tosa?</strong></p>
    <p>A pelagem tem função de proteção. Tosa muito rente pode:</p>
    <ul>
      <li>Expor a pele ao sol</li>
      <li>Aumentar risco de queimaduras</li>
      <li>Prejudicar a termorregulação em algumas raças</li>
    </ul>

    <p>A melhor decisão depende de raça, tipo de pelo e rotina. Uma avaliação veterinária (e, quando necessário, com grooming responsável) evita erro comum.</p>

    <h3><strong>Ambiente fresco em casa: conforto térmico com baixo custo</strong></h3>
    <p>Você não precisa transformar a casa em “hotel”. Pequenas mudanças já fazem diferença.</p>

    <p><strong>Ideias práticas</strong></p>
    <ul>
      <li>Ventilador direcionado para circulação, não direto no pet por horas.</li>
      <li>Piso fresco e acesso a áreas ventiladas.</li>
      <li>Tapete gelado (se o pet aceitar).</li>
      <li>Enriquecimento: brinquedos congeláveis, garrafa PET com água congelada dentro de um pano (com supervisão).</li>
    </ul>

    <h3><strong>Quando procurar um veterinário em Lages/SC?</strong></h3>
    <p>Você deve procurar atendimento se notar:</p>
    <ul>
      <li>Ofegação intensa que não melhora em pouco tempo</li>
      <li>Apatia, vômitos, diarreia persistente</li>
      <li>Coceira e feridas de pele</li>
      <li>Sinais de dor ao andar (pode ser queimadura nas patas)</li>
      <li>Suspeita de golpe de calor</li>
    </ul>

    <p>Se você está buscando um veterinário em Lages SC para orientar prevenção e rotina, uma consulta de verão é uma ótima ideia para ajustar antiparasitário, hidratação e cuidados com a pele.</p>

    <h3><strong>Checklist de Verão São Chico (para tutores)</strong></h3>
    <ul>
      <li>Antiparasitário em dia</li>
      <li>Água em mais de um ponto da casa</li>
      <li>Passeios fora do horário de pico</li>
      <li>Proteção de patas no asfalto quente</li>
      <li>Sinais de alerta de golpe de calor</li>
    </ul>

    <p>Quer ajuda para adaptar isso ao seu pet? Agende uma avaliação na Clínica Veterinária São Chico.</p>

    <h3><strong>Conclusão: verão seguro é verão com prevenção</strong></h3>
    <p>Com calor, o risco não está só “na rua”. Ele está na hidratação insuficiente, nos horários errados de passeio, na exposição solar e no atraso do antiparasitário. A boa notícia é que a proteção para pets no verão em Lages fica simples quando vira rotina.</p>

    <p>Se você quer ter certeza de que seu pet está bem preparado para a estação, a equipe da Clínica Veterinária São Chico pode orientar um plano de cuidados personalizado, do jeito certo para a realidade da nossa cidade.</p>

    <p>Agende uma consulta preventiva de verão e mantenha seu pet confortável e seguro durante toda a estação.</p>
  `,
  },
];

export function getPostBySlug(slug: string): Post | undefined {
  return posts.find((post) => post.slug === slug);
}

export function getRelatedPosts(currentSlug: string, limit = 3): Post[] {
  return posts.filter((post) => post.slug !== currentSlug).slice(0, limit);
}

export function getAllTags(): string[] {
  const allTags = posts.flatMap((post) => post.tags);
  return Array.from(new Set(allTags));
}

export function getAllCategories(): string[] {
  const allCategories = posts.map((post) => post.category);
  return Array.from(new Set(allCategories));
}
